import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"controllers"}},[_c(VBtn,{attrs:{"disabled":_vm.disabled,"color":"primary","rbt-target":"openUserCreation","large":""},on:{"click":function($event){return _vm.$emit('create:user')}}},[_vm._v(" "+_vm._s(_vm.$t("OrganizationUsers.buttons.createUser"))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }